import {Component, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";

@Component({
    selector: 'ral-externo',
    templateUrl: './externo.component.html',
    styleUrls: ['./externo.component.css']
})
export class ExternoComponent
{
    username: string = '';
    password: string = '';

    @ViewChild('routerOutlet', { static: true }) routerOutlet!: RouterOutlet;
    constructor(private http: HttpClient,private msalService: MsalService, private router: Router,private route : ActivatedRoute,) {}

    ngOnInit(){
        this.route.paramMap.subscribe(
            params=>
            {
                const user = params.get('user');
                if (user){
                    this.username = user;
                }

                const password = params.get('password');
                if (password){
                    this.password = password;
                }

                if(this.password != "" && this.username != ""){
                    this.authLogin();
                }
        });
    }
    //verifica si lanzar el evento de comprovacion de inputs
    onKeyDown(event: KeyboardEvent): void
    {
        if (event.key === 'Enter')
        {
            this.getValoresCampos();
        }
    }
    getValoresCampos():void
    {
        this.username = (document.getElementById('user') as HTMLInputElement).value.trim();
        this.password = (document.getElementById('pass') as HTMLInputElement).value.trim();

        if(this.username.length>0 && this.password.length>0)
        {
            this.authLogin();
        }
        else alert("Hay campos vacios");
    }

    authLogin(){
        this.username+="@ralarsa.com";
        this.loginExterno()
            .then((response:any)=>
            {
                //Guardamos el accessToken en el localStorage
                localStorage.setItem("accessToken",response.access_token);
                this.router.navigate(['/hub-externo']);

            })
            .catch((error:any)=>{alert("Credenciales invalidas");console.log(error);})
            .finally(()=>{

            });
    }
    loginExterno():Promise<TokenResponse>
    {
        let url = environment.externosWSBase + "/AuthExterno/";
        const body =
            {
                username: this.username,
                password: this.password
            };

        const httpOptions =
            {
                headers: new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': environment.baseWS}),

                params: new HttpParams({})
            }

        return new Promise<any>((resolve, reject) =>
        {
            this.http.post(url,body,httpOptions)
                .subscribe
                ({
                    next:(response:any)=>resolve(response),
                    error:(err)=>{reject(err)}
                });
        });
    }
}

interface TokenResponse
{
    token_type:   string//The value Bearer
    expires_on:   string//The token expire timestamp in Unix epoch time.
    access_token: string//The access token we needed to access the Graph API.
    refresh_token:string//A refresh token that can be used to acquire a new access token when the original expires.
}
